export const deepLinkStatuses = [
  'completed',
  'confirmed',
  'claimed',
  'validating',
  'validated_and_completed',
  'cancelled',
  'pending',
];
